import { Outlet } from "react-router-dom";

import UserDropdown from "../components/UserDropdown";
import SideNavbar from "../components/VTabBar/SideNavbar";

import {
  // SimplePaymentIcon,
  // SmartEscrowIcon,
  DashboardIcon,
  // IFIcon,
  // LogisticsIcon,
  // QualityAssuranceIcon,
  DealTrackerIcon,
  // DocumentTextIcon,
  BriefcaseIcon,
  GearIcon,
  HelpCircleIcon,
  BoxIcon,
} from "../components/Icons";

import {
  coming_soon,
  // coming_soon,
  dealTrackerContent,
  // invoiceContent,
  // logisiticsContent,
  paymentContent,
  procurementContent,
  // qualityContent,
} from "../constants/tooltipContents";
import { GreetUser } from "../components/Dashboard";
// import AccountOverViewIcon from "../components/Icons/AccountOverViewIcon";
import Navbar from "../components/Shared/Navbar";

const routes = [
  {
    id: 1,
    route: "/dashboard",
    name: "Dashboard",
    content: paymentContent,
    icon: <DashboardIcon className="size-6" />,
    disabled: false,
  },
  {
    id: 2,
    route: "/deal-tracker",
    name: "Deal Tracker",
    content: dealTrackerContent,
    icon: <DealTrackerIcon className="size-6" />,
    disabled: false,
  },

  {
    id: 3,
    route: "/procurement",
    name: "Procurement",
    content: procurementContent,
    icon: <BoxIcon className="size-6" />,
    disabled: false,
  },

  // {
  //   id: 3,
  //   route: "/logistics",
  //   name: "Logistics",
  //   content: logisiticsContent,
  //   icon: <LogisticsIcon className="size-7" />,
  //   disabled: false,
  // },

  // {
  //   id: 6,
  //   route: "/simple-payment",
  //   name: "Payment",
  //   content: paymentContent,
  //   icon: <SimplePaymentIcon className="size-7" />,
  //   disabled: false,
  // },
  // {
  //   id: 9,
  //   route: "/invoice-factoring",
  //   name: "Invoice Factoring",
  //   content: invoiceContent,
  //   icon: <IFIcon className="size-7" />,
  //   disabled: true,
  // },

  // {
  //   id: 4,
  //   route: "/quality-assurance",
  //   name: "Quality Assurance",
  //   content: qualityContent,
  //   icon: <QualityAssuranceIcon className="size-7" />,
  //   disabled: true,
  // },

  // {
  //   id: 4,
  //   route: "/smart-escrow",
  //   name: "Smart Escrow",
  //   icon: <SmartEscrowIcon className="size-7" />,
  //   disabled: true,
  // },

  // {
  //   id: 7,
  //   route: "/insurance",
  //   name: "Insurance",
  //   icon: <InsuranceIcon className="size-7" />,
  // },
  // {
  //   id: 4,
  //   route: "/smart-escrow",
  //   name: "Smart Escrow",
  //   icon: <SmartEscrowIcon className="size-7" />,
  //   disabled: true,
  //   content: "Coming soon",
  // },
  // {
  //   id: 8,
  //   route: "/transaction-summary",
  //   name: "Summary",
  //   icon: <ChartBreakoutCircle className="size-7" />,
  // },
];

const bottomLinks = [
  // {
  //   route: "account-overview",
  //   name: "Account Overview",
  //   icon: <AccountOverViewIcon className="size-6" />,
  // },
  // {
  //   route: "invoices",
  //   name: "Taram’s Invoices",
  //   icon: <DocumentTextIcon className="size-6" />,
  // },
  {
    route: "/registration",
    name: "Business Info",
    icon: <BriefcaseIcon className="size-6" />,
  },
  {
    route: "/security",
    name: "Security",
    icon: <GearIcon className="size-6" />,
  },
  {
    route: "/help-and-support",
    name: "Help & Support",
    icon: <HelpCircleIcon className="size-6" />,
  },
];

export type RoutesType = typeof routes;
export type LinkProps = RoutesType[number];

const VTabBarlayout = () => {
  return (
    <main className="flex min-h-screen bg-[#EAECF0]">
      <SideNavbar routes={routes} bottomLinks={bottomLinks} />

      <section className="relative flex-1 ml-[264px] min-h-screen transition-all duration-300 main_content">
        <DashboardNavbar />
        <section
          className="custom-container px-6 xl:px-10 pt-[100px] pb-10 transition-all duration-500 ease-in-out"
          id="main_content_outlet"
        >
          <Outlet />
        </section>
      </section>
    </main>
  );
};

export default VTabBarlayout;

function DashboardNavbar() {
  return (
    <Navbar>
      <GreetUser />
      <UserDropdown />
    </Navbar>
  );
}
